<template>
    <div class="user_list">
        <div class="row">
            <div class="col-5 col-sm-3">
                <h5>學員姓名</h5>
                <input type="text" v-model="name" placeholder="請輸入學員姓名" v-validate="'required|max:20'" :data-vv-scope="scope" :name="inputName" class="store_input" maxlength="20">
                <div class="errors_box">
                    <span>{{ errors.first(inputName, scope) }}</span>
                </div>
            </div>
            <div class="col-7 col-sm-3">
                <h5>學員手機</h5>
                <input type="tel" v-model="phone" placeholder="請輸入學員手機" v-validate="{ required: true, regex: /((?=(09))[0-9]{10})$/, max: 20 }" :data-vv-scope="scope" :name="inputPhone"
                    class="store_input" maxlength="20">
                <div class="errors_box">
                    <span>{{ errors.first(inputPhone, scope) }}</span>
                </div>
            </div>
            <div class="col-sm">
                <h5>電子信箱</h5>
                <input type="email" v-model="email" placeholder="請輸入電子信箱" v-validate="'required|max:40'" :data-vv-scope="scope" :name="inputEmail"
                    class="store_input" maxlength="40">
                <div class="errors_box">
                    <span>{{ errors.first(inputEmail, scope) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import { mapMutations } from 'vuex'

    export default {
        inject: ['$validator'],
        props: {
            index: {
                type: Number,
                required: true,
            },
            student: {
                type: Object,
                required: true,
            },
            scope: {
                type: String,
                default() {
                    return 'edit-student'
                },
            },
        },
        computed: {
            inputName() {
                return `name${this.index}`;
            },
            inputPhone() {
                return `phone${this.index}`;
            },
            inputEmail() {
                return `email${this.index}`;
            },
            name: {
                get() {
                    return _.get(this.student, 'Name');
                },
                set(val) {
                    this.setOrderDetailStudent({
                        name: val,
                    });
                },
            },
            phone: {
                get() {
                    return _.get(this.student, 'CellPhone');
                },
                set(val) {
                    this.setOrderDetailStudent({
                        phone: val,
                    });
                },
            },
            email: {
                get() {
                    return _.get(this.student, 'Email');
                },
                set(val) {
                    this.setOrderDetailStudent({
                        email: val,
                    });
                },
            },
        },
        created() {
            let obj = {};

            obj[this.inputName] = {
                required: '請輸入正確資訊',
                max: '不能大於20字'
            };
            obj[this.inputPhone] = {
                required: '請輸入正確資訊',
                regex: '請輸入正確資訊',
                max: '不能大於20字'
            };
            obj[this.inputEmail] = {
                required: '請輸入正確資訊',
                max: '不能大於40字'
            };

            const dict = {
                custom: obj,
                attributes: {},
            };

            dict.attributes[this.inputEmail] = ' ';


            this.$validator.localize('zh_TW', dict);
        },
        mounted() {
            this.validate();
        },
        methods: {
            ...mapMutations('orderDetail', ['setStudent']),
            setOrderDetailStudent(obj) {
                this.setStudent({
                    index: this.index,
                    ...obj,
                });
            },
            validate() {
                this.$validator.validateAll(this.scope);
            }
        },
    }
</script>